import {useContext, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import { PartnerEditShowContext } from '../partner-edit/PartnerEditShowContexts'

const KitDocumentoModalHeader = () => {
  const {setShowKitDocumentoModal} = useContext(PartnerEditShowContext)
  const [title, setTitle] = useState('')

  useEffect(() => {
    setTitle('Agregar')
  }, [])

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>KIT DE DOCUMENTO</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => setShowKitDocumentoModal(false)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {KitDocumentoModalHeader}
